import loadable from '@loadable/component';

export const FitandwellSiteWrapper = loadable(
  () => import(/* webpackChunkName: "fitandwell-site" */ './FitandwellSiteWrapper'),
);
